import React, { Component } from 'react'

import MainSection from './MainSection'
import BannerSection from './BannerSection'
import TemplatesArea from './TemplatesArea'
import EasyUse from './EasyUse'
import PremiumSection from './PremiumSection'
import CompareArea from './CompareArea'
import PremiumSectionEn from './PremiumSectionEn'
import GalleryAreaEn from './GalleryAreaEn'
import EcommerceSection from './EcommerceSection'
import DynamicSection from './DynamicSection'

class NewLanding extends Component {
    render() {
        const {
            totalTemplateCount,
            value: lang
        } = this.props
        return <>
            <MainSection
                {...this.props}
            />
            <TemplatesArea
                {...this.props}
                onThumbnailClicked={this.props.onThumbnailClicked}
                totalTemplateCount={totalTemplateCount}
            />
            {
                lang === 'ko'
                    ?
                    <>
                        {/* 
                        2024-09-27 마케팅팀 요청으로 인한 배너 숨김 처리
                        <BannerSection
                            {...this.props}
                        /> 
                        */}
						<DynamicSection
							{...this.props}
						/>
                        <EcommerceSection
                            {...this.props}
                        />
                        <EasyUse />
                        <PremiumSection
                            {...this.props}
                        />
                    </>
                    :
                    <>
                        <div className='wave premium'>
                            <img src='https://front.videomonster.com/images-7cuytg20/web/home/compare-area-wave.svg' alt="" />
                        </div>
                        <CompareArea
                            {...this.props}
                        />
                        <PremiumSectionEn
                            {...this.props}
                        />
                        <GalleryAreaEn
                            {...this.props}
                            onThumbnailClicked={this.props.onThumbnailClicked}
                        />
                    </>
            }
        </>
    }
}

export default NewLanding